export default __webpack_public_path__ + "static/media/logo.9bbed53e.png";